module.exports = __webpack_public_path__ + "img/34.bfec092b.jpg";